import axios from 'axios';

const TIMEZONE_API_KEY = import.meta.env.VITE_GOOGLE_TIMEZONE_API_KEY;

interface TimezoneData {
  status: string;
  timeZoneId: string;
}

enum TimezoneResponse {
  OK = 'OK',
}

export const getTimezone = async (
  lat: number,
  lng: number,
): Promise<string | null> => {
  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const response = await axios.get<TimezoneData>(
      'https://maps.googleapis.com/maps/api/timezone/json',
      {
        params: {
          location: `${lat},${lng}`,
          timestamp,
          key: TIMEZONE_API_KEY,
        },
      },
    );

    if (response.data.status !== TimezoneResponse.OK) {
      console.error('Error en Time Zone API:', response.data.status);
      return null;
    }
    return response.data.timeZoneId;
  } catch (error) {
    console.error('Error obteniendo timezone:', error);
    return null;
  }
};
